export default function allFieldsPerformed({ fields = {} }) {
  return Object.keys(fields).every((fieldName) => {
    const value = fields[fieldName];
    return value !== '' && value != null;
  });
}
